<template>
	<div v-if="show" @click.self="dismissModal()" class="fixed pin z-50 overflow-hidden bg-smoke-lighter flex">
		<div class="relative bg-grey-lightest shadow-modal w-full max-w-xl m-auto flex-col flex rounded overflow-hidden">
			<div class="w-full bg-green-light py-1"></div>
			<div class="px-3 border-b">
				<div class="flex pt-2 m-2 px-4">
					<div class="flex-2 text-left">
						<p class="text-lg font-extrabold">Mallar</p>
					</div>
					<div class="flex-1">
						<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
							<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
						</button>
					</div>
				</div>
			</div>

			<div class="max-h-75 overflow-scroll w-full py-4 text-left px-6">

				<div v-if="showForm" class="flex justify-center flex-wrap">
					<div v-if="pageHasObjects" class="w-3/4 mb-4">
						<div class="w-full px-3">
							<p class="text-left text-sm mb-2">
								Mallen kommer att skapas utifrån din första sida.
								Kundinformation och valda fält kommer inte sparas men valda sidinställningar som sidlayout, interpolationsinställningar, skala mm. kommer att sparas.<br>
								En bild kommer att sparas för att användas som förhandsvisning.</p>
							<p class="text-left font-semibold mb-2">Rubrik</p>
							<input class="input-text" v-model="title">

							<label class="ml-2 checkbox-container">
								<input type="checkbox" v-model="is_private">
								<span class="checkmark"></span>
								<span class="checkmark-text font-bold">Personlig mall</span>
							</label>
						</div>
					</div>
					<p v-else class="text-left text-red font-medium my-12">Du har inte lagt till något på din sida och kan därför inte spara den som en mall</p>
				</div>

				<div v-else-if="printTemplates.length" class="flex flex-wrap">
					<div v-for="template in printTemplates" :key="template.id" class="w-1/3 p-2">
						<div class="flex items-center mb-2">
							<svg v-if="defaultTemplate === template.id" class="h-6 w-6 text-yellow-dark fill-current" viewBox="0 0 24 24"><path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"/></svg>
							<div class="flex-grow pr-6">
								<p class="text-center text-xl" v-text="printTitle(template.title)"/>
							</div>
						</div>
						<div @click="selectTemplate(template)" :class="{'shadow-outline':selectedTemplate && selectedTemplate.id === template.id}" class="w-full p-1 rounded bg-white shadow border cursor-pointer" v-html="template.svg"/>
					</div>
				</div>

				<div v-else class="text-center py-12">
					<p class="text-2xl">Inga mallar tillagda för din region ännu!</p>
				</div>
			</div>

			<div :class="showForm || pages.length === 0 ? 'justify-end' : 'justify-between'" class="w-full flex bg-grey-lightish py-4 px-5">
				<div v-if="showForm" class="mr-4 flex">
					<button @click="showForm = false" class="py-2 px-2 text-sm text-center text-white block bg-grey-dark hover:bg-grey-darker rounded shadow-light font-bold">Avbryt</button>
					<button @click="save()" :class="{'disabled':showForm && title.length < 3}" class="ml-2 py-2 px-2 text-sm text-center text-white block bg-green hover:bg-green-dark rounded shadow-light font-bold">Spara</button>
				</div>
				<button v-else-if="pages.length" @click="showForm = true" class="py-2 px-2 text-sm text-center text-white block bg-green hover:bg-green-dark rounded shadow-light font-bold">Skapa ny mall</button>

				<div v-if="!showForm" class="flex">
					<button @click="removeSelectedTemplate()" :class="{'disabled':selectedTemplate === null || user.id !== selectedTemplate.user_id}" class="bg-red hover:bg-red-dark p-2 rounded shadow">
						<svg class="w-4 h-4 text-white fill-current" viewBox="0 0 24 24"><path d="M3 6v18h18v-18h-18zm5 14c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4-18v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 2h5.712z"/></svg>
					</button>
					<button @click="useAsDefault()" :class="{'disabled':selectedTemplate === null}" class="ml-2 bg-blue hover:bg-blue-dark p-2 font-medium text-sm text-white rounded shadow flex items-center">
						<svg class="h-4 w-4 fill-current" viewBox="0 0 24 24"><path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"/></svg>
						<p class="ml-2" v-text="selectedTemplateIsDefault ? 'Sluta använd som standard' : 'Använd som standard'"></p>
					</button>
					<button @click="useSelectedTemplate()" :class="{'disabled':selectedTemplate === null}" class="ml-2 bg-green hover:bg-green-dark p-2 font-medium text-sm text-white rounded shadow"> Lägg till sida från mall</button>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {

	data() {
		return {
			show: false,
			showForm: false,
			title: '',
			is_private: true,
			selectedTemplate: null
		}
	},

	mounted() {
		bus.$on('open-template-modal', this.openModal)
		bus.$on('page-returned-as-svg', this.svgReceieved)
	},

    beforeDestroy() {
        bus.$off('open-template-modal')
        bus.$off('page-returned-as-svg', this.svgReceieved)
	},

	computed: {
		...mapGetters({
			pages:				'layout/pages',
			printTemplates:		'template/templates',
			defaultTemplate:	'settings/defaultTemplate',
			user:				'auth/user',
		}),

		pageHasObjects() {
			return this.pages.length && (
				this.pages[0].objects.length > 1 ||
				Object.keys(this.pages[0].legendSettings).length ||
				Object.keys(this.pages[0].scale).length || 
				Object.keys(this.pages[0].analysisTextSettings).length ||
				Object.keys(this.pages[0].footerSettings).length ||
				Object.keys(this.pages[0].headerSettings).length
			)
		},

		selectedTemplateIsDefault() {
			return this.selectedTemplate && this.defaultTemplate === this.selectedTemplate.id
		}
	},

	watch: {
		showForm() {
			this.title = ''
			this.is_private = true
		}
	},

	methods: {

		save() {
			bus.$emit('get-page-svg', this.pages[0].id)
		},

		printTitle(title) {
			return title.charAt(0).toUpperCase() + title.slice(1);
		},

		selectTemplate(template) {
			if(this.selectedTemplate && template.id === this.selectedTemplate.id) {
				this.selectedTemplate = null
			} else {
				this.selectedTemplate = template
			}
		},

		removeSelectedTemplate() {
			if(this.selectedTemplate && this.user.id === this.selectedTemplate.user_id && confirm('Är du säker på att du vill ta bort mallen?')) {
				this.$store.dispatch('template/DELETE_TEMPLATE', this.selectedTemplate.id)
				.then(() => {
					this.selectedTemplate = null
					bus.$emit('show-notification', 'Mallen togs bort')
				})
			}
		},

		useAsDefault() {
			if(this.selectedTemplate) {
				if(this.selectedTemplateIsDefault) {
					this.$store.dispatch('settings/UPDATE_SETTING', {
						setting: 'defaultTemplate',
						value: null
					})
				} else {
					this.$store.dispatch('settings/UPDATE_SETTING', {
						setting: 'defaultTemplate',
						value: this.selectedTemplate.id
					})
				}
			}
		},

		useSelectedTemplate() {
			if(this.selectedTemplate) {
				this.$store.dispatch("layout/ADD_NEW_PAGE_FROM_TEMPLATE", JSON.parse(this.selectedTemplate.json));
				this.dismissModal()
			}
		},

		svgReceieved(svg) {
			// Fix the svg
			let svgArray = svg.split('\n')
			svgArray.splice(0,2)
			let reg = /(?:width="\d*" height="\d*" )/
			svgArray[0] = svgArray[0].replace(reg, '')

			this.$store.dispatch('template/ADD_TEMPLATE', {
				svg: svgArray.join('\n'),
				title: this.title,
				is_private: this.is_private,
				json: JSON.stringify({
					objects: this.pages[0].objects,
					interpolationSettings: this.pages[0].interpolationSettings,
					settings: {
						scale: this.pages[0].scale,
						scaleSettings: this.pages[0].scaleSettings,
						legendSettings: this.pages[0].legendSettings,
						showText: this.pages[0].showText,
						fontSize: this.pages[0].fontSize,
						paperType: this.pages[0].paperType,
						analysisTextSettings: this.pages[0].analysisTextSettings,
						footerSettings: this.pages[0].footerSettings,
						headerSettings: this.pages[0].headerSettings,
					},
				})
			}).then(() => {
				this.showForm = false
			})
		},

		openModal() {
			this.show = true
			document.getElementById("body").className = "overflow-y-hidden";
		},

		dismissModal() {
			this.show = false
			this.showForm = false
			this.selectedTemplate = null
			document.getElementById("body").className = "";
		},
	}
}
</script>